import React from "react";
import {Link} from 'react-router-dom'
import branding_header from '../images/branding_header'

export default function Branding() {
  return (
    <>
      <div class="page-wrapper sec-mar">
        <article
          id="post-17"
          class="post-17 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="17"
              class="elementor elementor-17"
            ></div>
          </div>
        </article>
      </div>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-f673421 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="f673421"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-041ee92"
            data-id="041ee92"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-2b60de4 elementor-widget elementor-widget-spinner_slider"
                data-id="2b60de4"
                data-element_type="widget"
                data-widget_type="spinner_slider.default"
              >
                <div class="elementor-widget-container">
                  <script></script>

                  <div class="banner-section3">
                    <div class="banner3-circle"></div>
                    <div class="banner3-circle3"></div>
                    <div class="banner3-circle2"></div>
                    <ul class="banner-social3 gap-5">
                      <li>
                        <a href="#">Twitter</a>
                      </li>
                      <li>
                        <a href="#">Facebook</a>
                      </li>
                      <li>
                        <a href="#">Instagram</a>
                      </li>
                    </ul>
                    <div class="swiper banner3">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                          <img
                            decoding="async"
                            // src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner31-1.png"
                            src={branding_header}
                            class="slider-bg"
                            alt=" slider_image"
                          />
                          <div class="container">
                            <div class="row d-flex justify-content-start align-items-center">
                              <div class="col-xl-7 col-lg-9">
                                <div class="banner3-content">
                                  <span>Welcome to Our Agency</span>
                                  <h2>Smart Ideas for your Brand are Here </h2>
                                  <p>
                                    Get the most of reduction in your teams
                                    operating costs for the whole product which
                                    creates amazing Website experiences.
                                  </p>

                                  <div class="button-group d-flex justify-content-lg-start justify-content-center align-items-center flex-wrap gap-4">
                                    <Link
                                      to="/about"
                                      class="eg-btn btn--primary3 btn--lg"
                                    >
                                      LEARN MORE
                                    </Link>
                                    <Link
                                      to="/contacts"
                                      class="eg-btn btn--transparent btn--lg"
                                    >
                                      GET IN TOUCH
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                          <img
                            decoding="async"
                            src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner32-1.png"
                            class="slider-bg"
                            alt=" slider_image"
                          />
                          <div class="container">
                            <div class="row d-flex justify-content-start align-items-center">
                              <div class="col-xl-7 col-lg-9">
                                <div class="banner3-content">
                                  <span>Welcome to Our Agency</span>

                                  <h2>Smart Ideas for your Brand are Here </h2>
                                  <p>
                                    Get the most of reduction in your teams
                                    operating costs for the whole product which
                                    creates amazing Website experiences.
                                  </p>

                                  <div class="button-group d-flex justify-content-lg-start justify-content-center align-items-center flex-wrap gap-4">
                                    <Link
                                      to="/about"
                                      class="eg-btn btn--primary3 btn--lg"
                                    >
                                      LEARN MORE
                                    </Link>
                                    <Link
                                      to="/contacts"
                                      class="eg-btn btn--transparent btn--lg"
                                    >
                                      GET IN TOUCH
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div class="banner3-pagination d-flex justify-content-center flex-column align-items-center gap-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-3452cc0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="3452cc0"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ef94e54"
            data-id="ef94e54"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-2ec5233 elementor-widget elementor-widget-spinner_services"
                data-id="2ec5233"
                data-element_type="widget"
                data-widget_type="spinner_services.default"
              >
                <div class="elementor-widget-container">
                  <script></script>

                  <div class="service3-section">
                    <div class="row justify-content-center g-4">
                      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="service-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <div class="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                            >
                              <path
                                d="M9.54102 0.15625C4.90234 0.996094 1.15234 4.6875 0.205078 9.3457C0 10.3125 0 10.5859 0 25C0 39.4141 0 39.6875 0.205078 40.6543C1.04492 44.7754 4.00391 48.1055 8.01758 49.4531C9.6582 50 9.58984 50 20.6836 50H30.8887L31.3086 49.7559C32.5195 49.043 32.5586 47.1094 31.377 46.3672L31.0059 46.1426L20.8984 46.0938C9.43359 46.0352 10.1465 46.084 8.34961 45.2148C6.66992 44.3945 5.60547 43.3301 4.78516 41.6504C3.89648 39.8145 3.95508 41.0254 3.95508 25C3.95508 8.97461 3.89648 10.1855 4.78516 8.34961C5.60547 6.66992 6.66992 5.60547 8.34961 4.78516C10.1855 3.89648 8.96484 3.95508 25.0488 3.95508H39.209L40.0781 4.17969C40.5469 4.29688 41.3184 4.58984 41.7871 4.83398C43.3789 5.6543 44.4336 6.73828 45.2148 8.34961C46.084 10.1465 46.0352 9.41406 46.0938 21.0156L46.1426 31.2305L46.4453 31.6113C47.2949 32.6758 48.7988 32.6758 49.6484 31.6113L49.9512 31.2305L49.9805 20.791C50 10.5566 50 10.3223 49.8047 9.3457C48.8477 4.6582 45.0781 0.966797 40.3906 0.146484C39.6387 0.0195312 37.6465 0 24.9121 0.00976562C12.7637 0.0195312 10.1758 0.0390625 9.54102 0.15625Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M11.0539 9.92187C10.1457 10.3809 9.71603 11.1719 9.78439 12.3047C9.83322 13.1543 10.1945 13.7793 10.8781 14.209C11.3176 14.4727 11.4348 14.502 12.2063 14.502C12.9777 14.502 13.0949 14.4727 13.5344 14.209C13.8274 14.0234 14.1203 13.7305 14.3059 13.4375C14.5695 12.998 14.5988 12.8809 14.5988 12.1094C14.5988 11.3379 14.5695 11.2207 14.3059 10.7812C13.8567 10.0586 13.2414 9.72656 12.3137 9.6875C11.6692 9.6582 11.5031 9.6875 11.0539 9.92187Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M19.3652 10.6055C18.7598 10.9668 18.457 11.5332 18.457 12.3047C18.457 13.0859 18.7598 13.6523 19.375 14.0137L19.7949 14.2578H29.3457H38.8965L39.3164 14.0137C39.9316 13.6523 40.2344 13.0859 40.2344 12.3047C40.2344 11.5234 39.9316 10.957 39.3164 10.5957L38.8965 10.3516H29.3359H19.7754L19.3652 10.6055Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M10.6738 18.418C10.0684 18.7793 9.76562 19.3457 9.76562 20.1172C9.76562 20.8984 10.0684 21.4648 10.6836 21.8262L11.1035 22.0703H25H38.8965L39.3164 21.8262C39.9316 21.4648 40.2344 20.8984 40.2344 20.1172C40.2344 19.3359 39.9316 18.7695 39.3164 18.4082L38.8965 18.1641H24.9902H11.084L10.6738 18.418Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M10.6738 26.2305C10.0684 26.5918 9.76562 27.1582 9.76562 27.9297C9.76562 28.7109 10.0684 29.2773 10.6836 29.6387L11.1035 29.8828H15.2344H19.3652L19.7852 29.6387C20.4004 29.2773 20.7031 28.7109 20.7031 27.9297C20.7031 27.1484 20.4004 26.582 19.7852 26.2207L19.3652 25.9766H15.2246H11.084L10.6738 26.2305Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M26.8848 26.2305C26.3086 26.5723 25.9766 27.1582 25.9766 27.8418C25.9766 28.6426 27.207 34.6191 27.6074 35.7715C28.1152 37.2363 28.8086 38.5352 29.7656 39.7949C30.3613 40.5762 37.4512 47.7246 38.3594 48.4473C39.6875 49.5117 41.0938 50 42.8711 50C44.6094 50 46.0156 49.5312 47.334 48.4961C49.0527 47.1484 50 45.1562 50 42.8711C50 41.0938 49.5117 39.6875 48.4473 38.3594C47.5195 37.1973 40.293 30.1074 39.4043 29.4824C38.3301 28.7207 36.9531 28.0078 35.7812 27.6074C34.6094 27.1973 28.6328 25.9766 27.832 25.9766C27.4316 25.9766 27.1875 26.0449 26.8848 26.2305ZM32.3535 30.8594C34.5703 31.3184 35.7031 31.7871 37.1094 32.8223C38.0469 33.5156 45.4395 40.9668 45.7129 41.5039C45.9082 41.875 45.9473 42.0898 45.9473 42.8711C45.9473 43.6523 45.9082 43.8672 45.7227 44.2188C45.1074 45.3711 44.1016 45.9961 42.8711 45.9961C41.5332 45.9961 41.5234 45.9863 37.002 41.4453C34.8242 39.248 32.8809 37.2266 32.6953 36.9629C31.7578 35.625 31.2988 34.4727 30.8594 32.3535C30.7031 31.5527 30.5469 30.8105 30.5176 30.6836C30.4688 30.498 30.498 30.4688 30.6836 30.5176C30.8105 30.5469 31.5527 30.7031 32.3535 30.8594Z"
                                fill="#A044FF"
                              ></path>
                            </svg>
                          </div>
                          <div class="content">
                            <h4>
                              <Link to="/webdesigning">
                                Website Devolopment
                              </Link>
                            </h4>
                            <p class="para">
                              The marketing practice of creating a name, symbol
                              or design that identifies and differentiates a
                              product from other products.
                            </p>
                          </div>
                          <Link
                            to="/webdesigning"
                            class="read-more-icon"
                          >
                            <i class="bi bi-arrow-right"></i>
                          </Link>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="service-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <div class="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_384_5457)">
                                <path
                                  d="M0.644531 0.185555C0.498047 0.283211 0.283203 0.498055 0.185547 0.644539C0.00976562 0.908211 0 1.16212 0 4.39454C0 7.62696 0.00976562 7.88087 0.185547 8.14454C0.283203 8.29102 0.498047 8.50587 0.644531 8.60352C0.908203 8.7793 1.16211 8.78907 4.39453 8.78907C7.62695 8.78907 7.88086 8.7793 8.14453 8.60352C8.68164 8.2422 8.78906 7.95899 8.78906 6.85548V5.85938L11.748 5.86915C14.5508 5.86915 14.6875 5.87891 14.4531 6.03516C10.8008 8.53516 8.10547 12.1387 6.79688 16.2988C6.50391 17.2266 6.10352 19.1797 6.00586 20.1367C5.9375 20.8008 5.9375 20.8008 5.53711 20.9863C4.48242 21.4551 3.56445 22.5 3.22266 23.6035C2.49023 25.9863 3.70117 28.4082 6.03516 29.209C6.76758 29.4629 8.07617 29.4629 8.80859 29.209C10.1562 28.75 11.1719 27.7344 11.6309 26.3965C11.8848 25.6543 11.8848 24.4531 11.6211 23.6035C11.2793 22.5098 10.2344 21.3281 9.29688 20.9766L8.97461 20.8594L9.04297 20.3125C9.25781 18.4473 9.79492 16.6992 10.6934 14.8926C11.5332 13.2227 12.4023 12.0117 13.7695 10.6445C15.4785 8.93555 17.3145 7.73438 19.4434 6.94337C21.0059 6.35743 20.9863 6.35743 21.377 6.94337C21.8164 7.5879 22.3633 8.04688 23.1445 8.42774C23.7598 8.73048 23.8281 8.74024 25 8.74024C26.1719 8.74024 26.2402 8.73048 26.8555 8.42774C27.6367 8.04688 28.1836 7.5879 28.623 6.94337C29.0137 6.35743 28.9941 6.35743 30.5566 6.94337C32.6855 7.73438 34.5215 8.93555 36.2305 10.6445C37.5977 12.0117 38.4668 13.2227 39.3066 14.8926C40.2051 16.6992 40.7422 18.4473 40.957 20.3125L41.0254 20.8594L40.7031 20.9766C39.7656 21.3281 38.7207 22.5098 38.3789 23.6035C37.6465 25.9863 38.8574 28.4082 41.1914 29.209C42.2461 29.5703 43.8867 29.4141 44.7949 28.8477C46.2207 27.9492 46.9727 26.6504 46.9727 25.0391C46.9727 23.2324 46.0156 21.6895 44.4629 20.9863C44.0625 20.8008 44.0625 20.8008 43.9941 20.1367C43.9551 19.7754 43.8184 18.9356 43.6914 18.2617C42.7441 13.4863 39.873 9.06251 35.9668 6.3672L35.2148 5.85938H38.2129H41.2109V6.85548C41.2109 7.95899 41.3184 8.2422 41.8555 8.60352C42.1191 8.7793 42.373 8.78907 45.6055 8.78907C48.8379 8.78907 49.0918 8.7793 49.3555 8.60352C49.502 8.50587 49.7168 8.29102 49.8145 8.14454C49.9902 7.88087 50 7.62696 50 4.39454C50 1.16212 49.9902 0.908211 49.8145 0.644539C49.7168 0.498055 49.502 0.283211 49.3555 0.185555C49.0918 0.00977325 48.8379 7.62939e-06 45.6055 7.62939e-06C42.373 7.62939e-06 42.1191 0.00977325 41.8555 0.185555C41.3184 0.546883 41.2109 0.830086 41.2109 1.92384V2.9297H35.2051H29.209L29.0234 2.50977C28.7207 1.85548 28.2617 1.29884 27.627 0.830086C25.4102 -0.800774 22.0996 0.0390701 20.9766 2.50977L20.791 2.9297H14.7949H8.78906V1.92384C8.78906 0.830086 8.68164 0.546883 8.14453 0.185555C7.88086 0.00977325 7.62695 7.62939e-06 4.39453 7.62939e-06C1.16211 7.62939e-06 0.908203 0.00977325 0.644531 0.185555ZM5.85938 4.39454V5.85938H4.39453H2.92969V4.39454V2.9297H4.39453H5.85938V4.39454ZM47.0703 4.39454V5.85938H45.6055H44.1406V4.39454V2.9297H45.6055H47.0703V4.39454ZM25.7227 3.2129C26.1426 3.4961 26.3672 3.89649 26.3672 4.39454C26.3672 4.89259 26.1426 5.29298 25.7227 5.57618C25.5469 5.6836 25.2637 5.76173 25 5.76173C24.2188 5.76173 23.6328 5.17579 23.6328 4.39454C23.6328 3.61329 24.2188 3.02735 25 3.02735C25.2637 3.02735 25.5469 3.10548 25.7227 3.2129ZM8.14453 23.8184C8.56445 24.1016 8.78906 24.502 8.78906 25C8.78906 25.7813 8.20312 26.3672 7.42188 26.3672C6.64062 26.3672 6.05469 25.7813 6.05469 25C6.05469 24.2188 6.64062 23.6328 7.42188 23.6328C7.68555 23.6328 7.96875 23.7109 8.14453 23.8184ZM43.3008 23.8184C43.7207 24.1016 43.9453 24.502 43.9453 25C43.9453 25.7813 43.3594 26.3672 42.5781 26.3672C41.7969 26.3672 41.2109 25.7813 41.2109 25C41.2109 24.7363 41.2891 24.4531 41.3965 24.2774C41.6797 23.8574 42.0801 23.6328 42.5781 23.6328C42.8418 23.6328 43.125 23.7109 43.3008 23.8184Z"
                                  fill="#A044FF"
                                ></path>
                                <path
                                  d="M24.2577 11.9629C24.0234 12.0898 22.6269 14.1113 18.0468 20.9766C14.7948 25.8496 12.0605 29.9805 11.9726 30.1465C11.7968 30.4883 11.7675 31.1035 11.9042 31.4746C11.953 31.6016 12.2753 32.0117 12.6171 32.3828C15.0683 35.0586 16.748 38.4082 17.3339 41.7969L17.4902 42.6953L17.0995 43.0273C16.162 43.8379 15.205 45.498 14.9023 46.8457C14.8144 47.2363 14.746 47.8906 14.746 48.3105C14.746 49.1504 14.8925 49.4824 15.3905 49.8145C15.664 49.9902 16.0253 50 24.9999 50C33.9745 50 34.3359 49.9902 34.6093 49.8145C35.1074 49.4824 35.2538 49.1504 35.2538 48.3105C35.2538 47.8906 35.1855 47.2363 35.0976 46.8457C34.7949 45.498 33.8378 43.8379 32.9003 43.0273L32.5097 42.6953L32.666 41.7969C33.2519 38.4082 34.9316 35.0586 37.3828 32.3828C37.7246 32.0117 38.0468 31.6016 38.0956 31.4746C38.2324 31.1133 38.2031 30.4883 38.0273 30.1562C37.705 29.5312 26.1913 12.3438 25.9374 12.1191C25.6054 11.8066 24.7167 11.7285 24.2577 11.9629ZM23.5351 22.4609V26.6504L23.1249 26.8359C22.0605 27.3145 21.1425 28.3496 20.8007 29.4629C20.0683 31.8457 21.2792 34.2676 23.6132 35.0684C24.6679 35.4297 26.3085 35.2734 27.2167 34.707C28.6425 33.8086 29.3945 32.5098 29.3945 30.8984C29.3945 29.082 28.4374 27.5488 26.8847 26.8359L26.4648 26.6504V22.4316V18.2129L30.6152 24.4434L34.7753 30.6738L34.1113 31.5039C32.0702 34.0723 30.5663 37.1973 29.8827 40.293L29.6581 41.2793L29.3066 41.2012C28.8476 41.0938 21.1523 41.0938 20.6933 41.2012L20.3417 41.2793L20.1171 40.293C19.4335 37.1973 17.9296 34.0723 15.8886 31.5039L15.2245 30.6738L19.3554 24.4727C21.6308 21.0547 23.496 18.2617 23.5156 18.2617C23.5253 18.2617 23.5351 20.1465 23.5351 22.4609ZM25.7226 29.6777C26.1425 29.9609 26.3671 30.3613 26.3671 30.8594C26.3671 31.6406 25.7812 32.2266 24.9999 32.2266C24.5019 32.2266 24.1015 32.002 23.8183 31.582C23.4277 30.9863 23.6425 30.0977 24.2773 29.6777C24.6484 29.4336 25.3515 29.4336 25.7226 29.6777ZM29.1894 44.3262C30.2929 44.707 31.2011 45.4883 31.7382 46.5039L32.041 47.0703H24.9999H17.9589L18.2616 46.5039C18.9355 45.2246 20.1659 44.3555 21.5917 44.1406C21.8847 44.0918 23.5741 44.0723 25.3417 44.082C28.4179 44.1016 28.5937 44.1113 29.1894 44.3262Z"
                                  fill="#A044FF"
                                ></path>
                              </g>
                              <defs>
                                <clipPath id="clip0_384_5457">
                                  <rect
                                    width="50"
                                    height="50"
                                    fill="white"
                                  ></rect>
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="content">
                            <h4>
                              <a href="#">
                                Digital Marketing
                              </a>
                            </h4>
                            <p class="para">
                              Drive traffic and online brand exposure with
                              virtual marketing and get more audience response
                              on social media network
                            </p>
                          </div>
                          <Link
                            to="/digitalmarketing"
                            class="read-more-icon"
                          >
                            <i class="bi bi-arrow-right"></i>
                          </Link>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="service-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <div class="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                            >
                              <path
                                d="M4.375 7.8125C4.375 6.90082 4.73716 6.02648 5.38182 5.38182C6.02648 4.73716 6.90082 4.375 7.8125 4.375H17.1875C18.0992 4.375 18.9735 4.73716 19.6182 5.38182C20.2628 6.02648 20.625 6.90082 20.625 7.8125V17.1875C20.625 18.0992 20.2628 18.9735 19.6182 19.6182C18.9735 20.2628 18.0992 20.625 17.1875 20.625H7.8125C6.90082 20.625 6.02648 20.2628 5.38182 19.6182C4.73716 18.9735 4.375 18.0992 4.375 17.1875V7.8125ZM29.375 7.8125C29.375 6.90082 29.7372 6.02648 30.3818 5.38182C31.0265 4.73716 31.9008 4.375 32.8125 4.375H42.1875C43.0992 4.375 43.9735 4.73716 44.6182 5.38182C45.2628 6.02648 45.625 6.90082 45.625 7.8125V17.1875C45.625 18.0992 45.2628 18.9735 44.6182 19.6182C43.9735 20.2628 43.0992 20.625 42.1875 20.625H32.8125C31.9008 20.625 31.0265 20.2628 30.3818 19.6182C29.7372 18.9735 29.375 18.0992 29.375 17.1875V7.8125ZM4.375 32.8125C4.375 31.9008 4.73716 31.0265 5.38182 30.3818C6.02648 29.7372 6.90082 29.375 7.8125 29.375H17.1875C18.0992 29.375 18.9735 29.7372 19.6182 30.3818C20.2628 31.0265 20.625 31.9008 20.625 32.8125V42.1875C20.625 43.0992 20.2628 43.9735 19.6182 44.6182C18.9735 45.2628 18.0992 45.625 17.1875 45.625H7.8125C6.90082 45.625 6.02648 45.2628 5.38182 44.6182C4.73716 43.9735 4.375 43.0992 4.375 42.1875V32.8125ZM29.375 32.8125C29.375 31.9008 29.7372 31.0265 30.3818 30.3818C31.0265 29.7372 31.9008 29.375 32.8125 29.375H42.1875C43.0992 29.375 43.9735 29.7372 44.6182 30.3818C45.2628 31.0265 45.625 31.9008 45.625 32.8125V42.1875C45.625 43.0992 45.2628 43.9735 44.6182 44.6182C43.9735 45.2628 43.0992 45.625 42.1875 45.625H32.8125C31.9008 45.625 31.0265 45.2628 30.3818 44.6182C29.7372 43.9735 29.375 43.0992 29.375 42.1875V32.8125Z"
                                stroke="#A044FF"
                                stroke-width="2.5"
                              ></path>
                            </svg>
                          </div>
                          <div class="content">
                            <h4>
                              <a href="#">
                                Advertisement
                              </a>
                            </h4>
                            <p class="para">
                              Display advertising, and other digital media.We
                              are here with our extraordinary services which can
                              help you to move your business to next level.
                            </p>
                          </div>
                          <Link
                            to="/advertisements"
                            class="read-more-icon"
                          >
                            <i class="bi bi-arrow-right"></i>
                          </Link>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="service-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <div class="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                            >
                              <path
                                d="M9.54102 0.15625C4.90234 0.996094 1.15234 4.6875 0.205078 9.3457C0 10.3125 0 10.5859 0 25C0 39.4141 0 39.6875 0.205078 40.6543C1.04492 44.7754 4.00391 48.1055 8.01758 49.4531C9.6582 50 9.58984 50 20.6836 50H30.8887L31.3086 49.7559C32.5195 49.043 32.5586 47.1094 31.377 46.3672L31.0059 46.1426L20.8984 46.0938C9.43359 46.0352 10.1465 46.084 8.34961 45.2148C6.66992 44.3945 5.60547 43.3301 4.78516 41.6504C3.89648 39.8145 3.95508 41.0254 3.95508 25C3.95508 8.97461 3.89648 10.1855 4.78516 8.34961C5.60547 6.66992 6.66992 5.60547 8.34961 4.78516C10.1855 3.89648 8.96484 3.95508 25.0488 3.95508H39.209L40.0781 4.17969C40.5469 4.29688 41.3184 4.58984 41.7871 4.83398C43.3789 5.6543 44.4336 6.73828 45.2148 8.34961C46.084 10.1465 46.0352 9.41406 46.0938 21.0156L46.1426 31.2305L46.4453 31.6113C47.2949 32.6758 48.7988 32.6758 49.6484 31.6113L49.9512 31.2305L49.9805 20.791C50 10.5566 50 10.3223 49.8047 9.3457C48.8477 4.6582 45.0781 0.966797 40.3906 0.146484C39.6387 0.0195312 37.6465 0 24.9121 0.00976562C12.7637 0.0195312 10.1758 0.0390625 9.54102 0.15625Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M11.0539 9.92187C10.1457 10.3809 9.71603 11.1719 9.78439 12.3047C9.83322 13.1543 10.1945 13.7793 10.8781 14.209C11.3176 14.4727 11.4348 14.502 12.2063 14.502C12.9777 14.502 13.0949 14.4727 13.5344 14.209C13.8274 14.0234 14.1203 13.7305 14.3059 13.4375C14.5695 12.998 14.5988 12.8809 14.5988 12.1094C14.5988 11.3379 14.5695 11.2207 14.3059 10.7812C13.8567 10.0586 13.2414 9.72656 12.3137 9.6875C11.6692 9.6582 11.5031 9.6875 11.0539 9.92187Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M19.3652 10.6055C18.7598 10.9668 18.457 11.5332 18.457 12.3047C18.457 13.0859 18.7598 13.6523 19.375 14.0137L19.7949 14.2578H29.3457H38.8965L39.3164 14.0137C39.9316 13.6523 40.2344 13.0859 40.2344 12.3047C40.2344 11.5234 39.9316 10.957 39.3164 10.5957L38.8965 10.3516H29.3359H19.7754L19.3652 10.6055Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M10.6738 18.418C10.0684 18.7793 9.76562 19.3457 9.76562 20.1172C9.76562 20.8984 10.0684 21.4648 10.6836 21.8262L11.1035 22.0703H25H38.8965L39.3164 21.8262C39.9316 21.4648 40.2344 20.8984 40.2344 20.1172C40.2344 19.3359 39.9316 18.7695 39.3164 18.4082L38.8965 18.1641H24.9902H11.084L10.6738 18.418Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M10.6738 26.2305C10.0684 26.5918 9.76562 27.1582 9.76562 27.9297C9.76562 28.7109 10.0684 29.2773 10.6836 29.6387L11.1035 29.8828H15.2344H19.3652L19.7852 29.6387C20.4004 29.2773 20.7031 28.7109 20.7031 27.9297C20.7031 27.1484 20.4004 26.582 19.7852 26.2207L19.3652 25.9766H15.2246H11.084L10.6738 26.2305Z"
                                fill="#A044FF"
                              ></path>
                              <path
                                d="M26.8848 26.2305C26.3086 26.5723 25.9766 27.1582 25.9766 27.8418C25.9766 28.6426 27.207 34.6191 27.6074 35.7715C28.1152 37.2363 28.8086 38.5352 29.7656 39.7949C30.3613 40.5762 37.4512 47.7246 38.3594 48.4473C39.6875 49.5117 41.0938 50 42.8711 50C44.6094 50 46.0156 49.5312 47.334 48.4961C49.0527 47.1484 50 45.1562 50 42.8711C50 41.0938 49.5117 39.6875 48.4473 38.3594C47.5195 37.1973 40.293 30.1074 39.4043 29.4824C38.3301 28.7207 36.9531 28.0078 35.7812 27.6074C34.6094 27.1973 28.6328 25.9766 27.832 25.9766C27.4316 25.9766 27.1875 26.0449 26.8848 26.2305ZM32.3535 30.8594C34.5703 31.3184 35.7031 31.7871 37.1094 32.8223C38.0469 33.5156 45.4395 40.9668 45.7129 41.5039C45.9082 41.875 45.9473 42.0898 45.9473 42.8711C45.9473 43.6523 45.9082 43.8672 45.7227 44.2188C45.1074 45.3711 44.1016 45.9961 42.8711 45.9961C41.5332 45.9961 41.5234 45.9863 37.002 41.4453C34.8242 39.248 32.8809 37.2266 32.6953 36.9629C31.7578 35.625 31.2988 34.4727 30.8594 32.3535C30.7031 31.5527 30.5469 30.8105 30.5176 30.6836C30.4688 30.498 30.498 30.4688 30.6836 30.5176C30.8105 30.5469 31.5527 30.7031 32.3535 30.8594Z"
                                fill="#A044FF"
                              ></path>
                            </svg>
                          </div>
                          <div class="content">
                            <h4>
                              <a href="#">
                                Product Designing
                              </a>
                            </h4>
                            <p class="para">
                              The process designers use to blend user needs with
                              business goals to help brands make consistently
                              successful products
                            </p>
                          </div>
                          <Link
                            to="/services"
                            class="read-more-icon"
                          >
                            <i class="bi bi-arrow-right"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* our branding services */}
      <div className="container mt-5">
        <div className="row text center">
          <h1>
            <strong>Our Branding Services</strong>
          </h1>
          <p>
            The marketing practice of creating a name, symbol or design that
            identifies and differentiates a product from other products. An
            effective brand strategy gives you a major edge in increasingly
            competitive markets
          </p>
        </div>
      </div>

{/* main section */}
{/* indoor branding */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Indoor Branding

-</span>
                    <h3  className="text-white">
                    Indoor Branding


                    </h3>
                    <p class="para mb-0 ">
                    Indoor branding is big business and it often happens that people and businesses can get great exposure from using indoor media platforms


                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="https://api.whatsapp.com/send/?phone=%2B919158111116&text&type=phone_number&app_absent=0" class="eg-btn btn--primary btn--lg">
                     Book Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://5.imimg.com/data5/AM/CR/OZ/SELLER-54884671/indoor-branding-500x500.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* outdoor branding */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://www.curvearro.com/wp-content/uploads/2019/11/outdoor-advertising_curvearro.jpeg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Out Door Branding-</span>
                    <h3  className="text-white">
                    Out Door Branding
                    </h3>
                    <p class="para mb-0 ">
                    Out Door branding works well for promoting your product in specific geographic areas. While billboards, bus benches, and transit advertising can be very effective for the small business. </p>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="https://api.whatsapp.com/send/?phone=%2B919158111116&text&type=phone_number&app_absent=0" class="eg-btn btn--primary btn--lg">
                     
                     Book Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* B2B */}
      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-B2B Branding-</span>
                    <h3  className="text-white">
                    B2B Branding
                    </h3>
                    <p class="para mb-0 ">
                    B2B Branding is not only a approach towards other businesses but it helps to build credibility and equity of brand in market. B2B Branding is vast concept of Branding. 
                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="https://api.whatsapp.com/send/?phone=%2B919158111116&text&type=phone_number&app_absent=0" class="eg-btn btn--primary btn--lg">
                     Book Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://t4.ftcdn.net/jpg/01/99/79/67/360_F_199796792_Q0PWwJtMUDNE8itq56lYzM8x4SrntcMA.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* our work example */}
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-c4df9f8 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="c4df9f8"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-a4090ef"
            data-id="a4090ef"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-eeddb87 elementor-widget elementor-widget-spinner_heading"
                data-id="eeddb87"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    {/* <span>-Creative Portfolio-</span> */}
                    <h3  className="text-white">A Small Look To Branding Work!
</h3>
                    {/* <p class="para mb-0">
                      Get the most of reduction in your teams operating costs
                      for the whole product
                      <br />
                      which creates amazing UI/UX experiences.
                    </p> */}
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-1c15451 elementor-widget elementor-widget-spinner_projects"
                data-id="1c15451"
                data-element_type="widget"
                data-widget_type="spinner_projects.default"
              >
                <div class="elementor-widget-container">
                  <script></script>

                  <div class="portfolio-section">
                    <div class="row justify-content-center align-items-start g-4 position-relative">
                      <div class="col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="portfolio-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <img
                            loading="lazy"
                            width="420"
                            height="420"
                            src="https://i.pinimg.com/736x/f9/39/4d/f9394d7e5fb03c9611bef6e41514551a.jpg"
                            class="attachment-egns-project-grid size-egns-project-grid wp-post-image"
                            alt=""
                            decoding="async"
                            srcset="https://i.pinimg.com/736x/f9/39/4d/f9394d7e5fb03c9611bef6e41514551a.jpg"
                            sizes="(max-width: 420px) 100vw, 420px"
                          />
                          <div class="overlay">
                            <div class="overlay-content">
                              <p>Banner </p>
                              <h4>
                                <a href="#">
                                 Banner
                                </a>
                              </h4>
                              {/* <a href="#"> */}
                                {/* <i class="bi bi-arrow-up-right"></i> */}
                              {/* </a> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="portfolio-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <img
                            width="420"
                            height="420"
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmhS1Mar-hITBLwjwsfhdVQbBYXu32MXoRnQ&usqp=CAU"
                            class="attachment-egns-project-grid size-egns-project-grid wp-post-image"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            srcset="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmhS1Mar-hITBLwjwsfhdVQbBYXu32MXoRnQ&usqp=CAU"
                            sizes="(max-width: 420px) 100vw, 420px"
                          />
                          <div class="overlay">
                            <div class="overlay-content">
                              <p>Vinyl </p>
                              <h4>
                                <a href="#">
                                Vinyl
                                </a>
                              </h4>
                              {/* <a href="https://www.spinner-wp.egenslab.com/projects/pocket-sized-notebooks-hold-2/">
                                <i class="bi bi-arrow-up-right"></i>
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6 col-sm-10">
                      <div
                          class="portfolio-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <img
                            width="420"
                            height="420"
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSATJhPP8ujLrsHDWp3tMjnSDMZ7unOF652A&usqp=CAU"
                            class="attachment-egns-project-grid size-egns-project-grid wp-post-image"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            srcset="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSATJhPP8ujLrsHDWp3tMjnSDMZ7unOF652A&usqp=CAU"
                            sizes="(max-width: 420px) 100vw, 420px"
                          />
                          <div class="overlay">
                            <div class="overlay-content">
                              <p>Product Holding
 </p>
                              <h4>
                                <a href="#">
                                Product Holding

                                </a>
                              </h4>
                              {/* <a href="https://www.spinner-wp.egenslab.com/projects/premium-water-bottle-design/">
                                <i class="bi bi-arrow-up-right"></i>
                              </a> */}
                            </div>
                          </div>
                        </div>

                      
                      </div>

                      <div class="col-lg-4 col-md-6 col-sm-10">
                      <div
                          class="portfolio-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <img
                            width="420"
                            height="420"
                            src="https://mir-s3-cdn-cf.behance.net/projects/404/418b76113079553.Y3JvcCw5MjAsNzIwLDE4MCww.jpg"
                            class="attachment-egns-project-grid size-egns-project-grid wp-post-image"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            srcset="https://mir-s3-cdn-cf.behance.net/projects/404/418b76113079553.Y3JvcCw5MjAsNzIwLDE4MCww.jpg"
                            sizes="(max-width: 420px) 100vw, 420px"
                          />
                          <div class="overlay">
                            <div class="overlay-content">
                              <p>Exhibition Stalls
 </p>
                              <h4>
                                <a href="#">
                                  Exhibition Stalls

                                </a>
                              </h4>
                              {/* <a href="https://www.spinner-wp.egenslab.com/projects/mobile-application-design/">
                                <i class="bi bi-arrow-up-right"></i>
                              </a> */}
                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="portfolio-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <img
                            width="420"
                            height="420"
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTS9f_rYSyoGtYorjMAsEC9v0h1fjk3ZqhkJw&usqp=CAU"
                            class="attachment-egns-project-grid size-egns-project-grid wp-post-image"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            srcset="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTS9f_rYSyoGtYorjMAsEC9v0h1fjk3ZqhkJw&usqp=CAU"
                            sizes="(max-width: 420px) 100vw, 420px"
                          />
                          <div class="overlay">
                            <div class="overlay-content">
                              <p>Pramotional Events
 </p>
                              <h4>
                                <a href="#">
                                Pramotional Events

                                </a>
                              </h4>
                              {/* <a href="https://www.spinner-wp.egenslab.com/projects/energy-drinks-bottle-design/">
                                <i class="bi bi-arrow-up-right"></i>
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="portfolio-item3 wow fadeInUp"
                          data-wow-duration="1.5s"
                          data-wow-delay=".2s"
                        >
                          <img
                            width="420"
                            height="420"
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-GdnmeewE1qksIA-IQ7pr_JuB96wZwcTmgg&usqp=CAU"
                            class="attachment-egns-project-grid size-egns-project-grid wp-post-image"
                            alt=""
                            decoding="async"
                            loading="lazy"
                            srcset="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-GdnmeewE1qksIA-IQ7pr_JuB96wZwcTmgg&usqp=CAU"
                            sizes="(max-width: 420px) 100vw, 420px"
                          />{" "}
                          <div class="overlay">
                            <div class="overlay-content">
                              <p>Brochures & Handbills
 </p>
                              <h4>
                                <a href="#">
                                Brochures & Handbills

                                </a>
                              </h4>
                              {/* <a href="https://www.spinner-wp.egenslab.com/projects/3d-illustration-design/">
                                <i class="bi bi-arrow-up-right"></i>
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
